module.exports = __webpack_public_path__ + "img/map_Z3.2.A.02.790c2a54.svg";